// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"97ce1acf","198":"5ea5f5eb","787":"73f047a7"}[chunkId] + ".chunk.js";
};